import { createSelector } from 'reselect'

const getUserData = state => state.user.data

const userFullNameSelector = createSelector(
	[ getUserData ],
	userData => {
		const fullNameParts = []
		if (userData) {
			if (userData.firstName) {
				fullNameParts.push(userData.firstName)
			}
			if (userData.lastName) {
				fullNameParts.push(userData.lastName)
			}
		}
		return fullNameParts.join(' ')
	}
)

export default userFullNameSelector
